export const userPrefix = '/prefix-api/store-user' // 用户接口前缀
export const goodsPrefix = '/prefix-api/store-product' // 用户接口前缀
export const orderPrefix = '/prefix-api/store-order' // 用户接口前缀
export const logisticsPrefix = '/prefix-api/store-logistics' // 物流接口前缀
export const payPrefix = '/prefix-api/store-payment' // 支付接口
export const commonPrefix = '/prefix-api/store-resource' // 支付接口
export const packagePrefix = '/prefix-api/store-storage' // 包裹接口
export const marketPrefix = '/prefix-api/store-marketing' // 促销接口
export const translatorPrefix = '/prefix-api/store-translator' // 翻译接口
